import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { PropTypes } from 'prop-types';
import { service, translate } from '../services';
import { 
  combineDispatchers, 
  combineStates, 
  configuratorDispatcher,
  messageDispatcher, 
  popupDispatcher ,
  siteSettingsState,
  nodeState
} from '../store';
import { ConfiguratorPage } from '../site';
import { findInPropertyPath } from '../util';

class EditConfigurationComponent extends Component {
  constructor() {
    super();
    this.state = {
      isConfigurationReady: false,
      products: null,
      configuration: null,
      isModelConfigurator: false,
      nodeCID: null,
    };
  }

  componentDidMount() {
    const { hash, siteSettings, node } = this.props;
    const { modelConfigurators } = siteSettings.properties;
    service( 'edit' )
      .get( hash )
      .then( ( { data } ) => {
        const product = data[0];
        const initialQuantity = data[0].properties.Quantity;
        const name = product.title;
        const configuration = data.map( prod => { return { productName : prod.title, accessories: prod.children.map( child => ( { key: child.properties.AccessoryParent, value: child.title })) }});
        const assemblyType = data[0].properties["SelectionType"];
        return service( 'getConfiguration' ).post( configuration ).then( response => {
            const product = response.data.configurations.first();
            product.amount = !product.amount && initialQuantity; 
            product.additionalProducts = response.data.configurations.slice( 1 );
            let title = `${translate( 'Configure {product}', { product: product.code} )}`;
            if(product.additionalProducts.length > 0){
              title = `${translate( 'Configure {product}', { product: product.code})} + ${product.additionalProducts[0].code}`;
            }
            if(modelConfigurators?.includes(product.materialName)) {
              const selected = findInPropertyPath( node, 'children', child => child.configuratorName === product.materialName ).firstOrDefault();
              const nodeCID = product.nodeCID || selected?.nodeId || selected?.uuid || product.materialName;
              product.importAccessories = data[0].children.map(c => ({accessoryCode: c.properties.AccessoryCode, quantity: c.properties.Quantity, description: c.properties.AccessoryDesc}))
              this.props.loadProductFromModelConfigurator({...product, nodeCID : nodeCID});
              this.setState( { isModelConfigurator: true, nodeCID: nodeCID } );
              return null;
            }
            return this.props.setPopup( {
              title: title,
              onClose: () => name && setTimeout( () => this.props.removeConfiguration( { name } ), 0 ),
              component: <ConfiguratorPage product={ product } isPopup assemblyType = { assemblyType } isEdit={true}/>,
              showHeader: true,
              keepOpen: true,
              isEdit:true,
              className:"edit-configure-page-overlay"
            } );
          } )
          .then( () => this.setState( { completed: true, isConfigurationReady: true, name  } ) )
          .catch( err => {
            console.log( err );
            this.props.addMessage( { timeout: 10000, messageType: 'error', messageText: translate( 'An error occured during loading the configuration' ) } );
            this.setState( { failed: true, isConfigurationReady: true } );
          } )
      } );
  }
  render() {
    const { isConfigurationReady, failed,isModelConfigurator,nodeCID } = this.state;
    if (!isConfigurationReady) {
      return null;
    }
    const { name } = this.state;
    if( !failed ) {
      if(isModelConfigurator) {
        return <Redirect to={ `/reconfigure/${nodeCID}` } />;
      } else {
      return <Redirect to={ `/configure/${name}` } />;
      }
    }
    const { defaultLandingPage } = this.props;
    return <Redirect to={ defaultLandingPage } />;
  }
}

EditConfigurationComponent.propTypes = {
  hash: PropTypes.string.isRequired,
  defaultLandingPage: PropTypes.string.isRequired
};

export const EditConfiguration = connect( 
  combineStates(siteSettingsState, nodeState),
  combineDispatchers( configuratorDispatcher, messageDispatcher, popupDispatcher ) 
)( EditConfigurationComponent );